import {combineReducers} from "redux";
import homepageViewModel from "./homepageViewModel"

const rootViewModel = combineReducers({
    homepageViewModel,
});

export default rootViewModel;
